import { ButtonIcon, FontAwesomeIcon, Stack } from "@skailer-com/uikit";
import { ComponentProps, forwardRef, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface SearchProps extends ComponentProps<"input"> {
  value?: string;
  placeholder?: string;
  borderless?: boolean;
  innerPadding?: boolean;
  clearable?: boolean;
  onClear?: () => void;
  leadingSlot?: ReactNode;
  hideSearchIcon?: boolean;
}

export const Search = forwardRef<HTMLInputElement, SearchProps>(function Input(
  {
    placeholder = "",
    disabled,
    readOnly,
    className,
    value,
    borderless,
    innerPadding,
    clearable = false,
    onClear,
    leadingSlot,
    hideSearchIcon = false,
    ...rest
  }: SearchProps,
  ref
) {
  return (
    <Stack
      direction={"horizontal"}
      gap={"sm"}
      items={"center"}
      className={twMerge(
        "h-12 w-full focus-within:border-brand-dark",
        !borderless ? "border-b border-dark/10" : undefined,
        innerPadding ? "px-6" : undefined
      )}
    >
      {!hideSearchIcon && (
        <FontAwesomeIcon icon={"fa-light fa-search"} className={"text-secondary"} />
      )}
      {leadingSlot}
      <input
        className={twMerge(
          "outline-0 bg-transparent focus:outline-0 w-full",
          "text-base",
          className
        )}
        ref={ref}
        type={"text"}
        value={value || ""}
        placeholder={placeholder}
        readOnly={readOnly}
        disabled={disabled}
        {...rest}
      />
      {value && clearable && (
        <ButtonIcon
          variant={"plain"}
          size={"sm"}
          icon={<FontAwesomeIcon icon={"fa-light fa-times"} />}
          onClick={onClear}
        />
      )}
    </Stack>
  );
});
